import Muuri from 'muuri'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const REVEAL_DIRS = [
  { y: 70 },
  { x: -70 },
  { y: -70 },
  { x: 70 },
]

export default class MasonryGrid {
  constructor(el) {
    this.el = el
    this.section = el.closest('.masonry-grid')
    this.filtersEl = this.section.querySelector('.masonry-grid--filter')
    this.revealDone = false
    this.init()
  }

  init() {
    const grid = new Muuri(this.el, {
      items: '.masonry-grid--item',
      layoutDuration: 450,
      layoutEasing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      showDuration: 400,
      showEasing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      hideDuration: 250,
      hideEasing: 'cubic-bezier(0.55, 0, 1, 0.45)',
      visibleStyles: { opacity: '1', transform: 'translateY(0px)' },
      hiddenStyles: { opacity: '0', transform: 'translateY(18px)' },
    })

    if (this.filtersEl) {
      this.filtersEl.addEventListener('click', (e) => {
        const li = e.target.closest('li[data-filter]')
        if (!li) return

        const filterValue = li.getAttribute('data-filter') || '*'

        grid.filter((item) => {
          const el = item.getElement()
          if (filterValue === '*') return true
          return el.matches(filterValue)
        })

        this.filtersEl.querySelectorAll('li').forEach(n => n.classList.remove('is-active'))
        li.classList.add('is-active')
      })
    }

    const relayout = () => grid.refreshItems().layout()

    grid.on('layoutEnd', () => {
      if (this.revealDone) return
      this.revealDone = true
      ScrollTrigger.refresh()
      this.initReveal()
    })

    window.addEventListener('load', relayout)
    this.el.querySelectorAll('img').forEach((img) => {
      if (img.complete) return
      img.addEventListener('load', relayout, { once: true })
      img.addEventListener('error', relayout, { once: true })
    })
  }

  initReveal() {
    this.el.querySelectorAll('.masonry-grid--card').forEach((card, i) => {
      const dir = REVEAL_DIRS[i % REVEAL_DIRS.length]
      gsap.set(card, { ...dir, opacity: 0 })
      gsap.to(card, {
        x: 0,
        y: 0,
        opacity: 1,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 88%',
          toggleActions: 'play none none none',
        },
      })
    })
  }
}
